// React and core libraries
import * as React from "react";

// Internal components
import { MultiSelectFilter } from "../../components/system/multi-select-filter";

// Internal utilities, hooks, and contexts
import { useAllTagValues, useTags } from "../../crud/tags/hooks";
import { useScopedContext } from "../../shared-components/ScopeSelector";

// Relative imports (components from same directory)
import { TagFilter } from "./types";

type ClusterFilterFieldProps = {
  tagFilters?: TagFilter[];
  setTagFilters: (tagFilters: TagFilter[]) => void;
  clusterNameFilter: string;
  setClusterNameFilter: (clusterNameFilter: string) => void;
};

export const ClusterFilterField = ({
  tagFilters,
  setTagFilters,
  clusterNameFilter,
  setClusterNameFilter,
}: ClusterFilterFieldProps): React.ReactElement => {
  const [scope] = useScopedContext();

  const { data: tags } = useTags({
    ...(scope.type === "compound" ? { compoundScope: scope.name } : {}),
    ...(scope.type === "account" ? { account: scope.name } : {}),
    ...(scope.type === "organization" ? { organization: scope.name } : {}),
    ...(scope.type === "user" ? { user: scope.name } : {}),
    systemTags: true,
  });

  const { data: allTagValues } = useAllTagValues({
    ...(scope.type === "compound" ? { compoundScope: scope.name } : {}),
    ...(scope.type === "account" ? { account: scope.name } : {}),
    ...(scope.type === "organization" ? { organization: scope.name } : {}),
    ...(scope.type === "user" ? { user: scope.name } : {}),
  });

  const handleFiltersChange = (filters: TagFilter[]) => {
    const formattedFilters = filters.map((filter) =>
      // Remove trailing ":*" from "match any" tag filters before sending to backend
      filter?.endsWith(":*") ? filter.slice(0, -2) : filter,
    );
    setTagFilters(formattedFilters);
  };

  return (
    <MultiSelectFilter
      tags={tags}
      allTagValues={allTagValues}
      selectedFilters={tagFilters || []}
      inputValue={clusterNameFilter}
      onFiltersChange={handleFiltersChange}
      onInputChange={setClusterNameFilter}
      placeholder="Filter by tags and/or by cluster name..."
    />
  );
};
